export const APPLICATION_SUBMITTED = '/application-submitted';
export const AVAILABLE_AGENTS_ROUTE = '/available-agents';
export const CCPA_ROUTE = '/ccpa-policy';
export const COMPARE_PLANS = '/compare-plans';
export const CONFIRM_EMAIL = '/confirm-email';
export const CONTACT_AGENT_ROUTE = '/contact-agent';
export const CONTACT_US_ROUTE = '/contact-agent-1';
export const COVERAGE_OPTIONS_ROUTE = '/guide/coverage-options';
export const CREATE_ACCOUNT_ROUTE = '/create-account';
export const DO_NOT_SELL_INFO =
    'https://privacyportal.onetrust.com/webform/ee1cd67a-fc19-4a8a-a048-465b10a9fefd/8a391573-2b45-49cc-a794-9ba6557de300';
export const ENROLLMENT_CHECKOUT_ROUTE = '/continue-checkout';
export const ENROLLMENT_ROUTE = '/guide/enrollment';
export const LEARNING_CENTER_ROUTE = '/learning-center';
export const MAINTENANCE_ROUTE = '/maintenance';
export const MANAGE_ACCOUNT_ROUTE = '/manage-account';
export const MEDICARE_BASICS_ROUTE = '/guide/medicare-basics';
export const MOBILE_TERMS = '/mobile-terms-and-conditions';
export const CONTACT_AN_AGENT_ROUTE = '/contact-an-agent';
export const OUR_COMMITMENT_ROUTE = '/our-commitment';
export const PARTS_OF_MEDICARE_ROUTE = '/guide/parts-of-medicare';
export const PASSWORD_UPDATED_ROUTE = '/password-updated';
export const PLANS_ROUTE = '/plans';
export const PLAN_ROUTE = '/plan/:planId/:zip/:fips';
export const PRIVACY_NOTICE_ROUTE = '/privacy-notice';
export const REGISTRATION_COMPLETE = '/registration-complete';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const REQUEST_CALL_BACK = '/request-call-back';
export const REQUEST_CALL_BACK_FORM = '/request-call-back-form';
export const SIGN_IN_OIDC_ROUTE = '/signin-oidc';
export const SIGN_IN_OIDC_SILENT_ROUTE = '/signin-oidc-silent';
export const SIGN_IN_ROUTE = '/login';
export const SIGN_OUT_OIDC_ROUTE = '/signout-oidc';
export const TERMS_ROUTE = '/terms-of-service';
export const THANK_YOU_ROUTE = '/thank-you';
export const VERIFY_EMAIL_ROUTE = '/verify-email';
export const WELCOME_ROUTE = '/welcome';
export const AUTHENTICATED_ROUTES = [MANAGE_ACCOUNT_ROUTE];
